import React from "react";

export default function Nav() {
  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-bg/85 backdrop-blur-md laptop:px-10">
      <div className="container mx-auto flex h-14 items-center justify-between px-6">
        <a
          href="/"
          className="font-heading text-[15px] font-bold tracking-tight text-text no-underline"
        >
          lab<span className="text-lime">.</span>
          <span className="font-serif text-[18px] italic text-lime">
            radical
          </span>
        </a>
        <ul className="hidden list-none items-center gap-8 laptop:flex">
          <li>
            <a
              href="/#services"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="/#swap"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              AI search
            </a>
          </li>
          <li>
            <a
              href="/#how"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              Process
            </a>
          </li>
          <li>
            <a
              href="/#who"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              Who we help
            </a>
          </li>
          <li>
            <a
              href="/#about"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              Studio
            </a>
          </li>
          <li>
            <a
              href="/faq"
              className="text-xs font-medium text-muted no-underline transition-colors hover:text-text"
            >
              FAQ
            </a>
          </li>
        </ul>
        <a
          href="/#contact"
          className="rounded-full bg-lime px-[1.1rem] py-[0.45rem] text-xs font-bold text-bg no-underline transition-opacity hover:opacity-85"
        >
          Start a project ↗
        </a>
      </div>
    </nav>
  );
}
